export const heroData = {
  title: 'j9官方平台·j9正版入口',
  subtitle: '备受用户信赖的综合娱乐平台，为您提供丰富游戏体验、安全支付保障与极速提款服务',
  cta_primary: '立即注册',
  cta_secondary: '了解更多',
};

export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '多重加密技术保障用户信息和资金安全，持有正规运营资质，让您放心娱乐无后顾之忧。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速提款',
    description: '智能审核系统实现秒级到账，支持多种提款方式，提款流程简单快捷，资金秒到无忧。',
  },
  {
    icon: 'ri-gamepad-line',
    title: '海量游戏',
    description: '汇聚数千款精品游戏，涵盖棋牌、电子、体育、电竞等多种类型，满足各类玩家需求。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天客服',
    description: '7×24小时专业客服团队在线守候，随时解答您的疑问，提供贴心周到的服务体验。',
  },
];

export const stats = [
  { value: '500万+', label: '注册用户' },
  { value: '3000+', label: '精品游戏' },
  { value: '99.9%', label: '支付成功率' },
  { value: '10秒', label: '平均提款速度' },
];

export const testimonials = [
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20professional%20headshot%20warm%20smile%20clean%20background%20studio%20lighting%20simple%20composition&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '在j9平台玩了快两年了，提款速度真的是没话说，基本上申请后几分钟就到账了。游戏种类也很丰富，推荐给身边很多朋友了！',
    date: '2026-07-28',
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20friendly%20smile%20professional%20headshot%20studio%20lighting%20clean%20neutral%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '作为一个新手玩家，j9的界面设计很友好，上手非常容易。客服态度也很好，有一次遇到问题，客服秒回帮我解决了。',
    date: '2026-07-25',
  },
  {
    name: '王先生',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20confident%20expression%20professional%20headshot%20warm%20studio%20lighting%20simple%20neutral%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '对比过好几个平台，j9的优惠活动是最给力的。充值返利、签到奖励、节日活动都很丰富，而且规则透明没有套路。',
    date: '2026-07-20',
  },
  {
    name: '赵先生',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20casual%20smile%20headshot%20studio%20lighting%20clean%20neutral%20background%20warm%20expression&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 4,
    comment: 'j9的体育竞猜板块做得特别好，赛事覆盖全面，赔率很合理。界面流畅不卡顿，体验感满分。就是希望游戏种类能再多一些。',
    date: '2026-07-18',
  },
  {
    name: '陈女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20warm%20genuine%20smile%20headshot%20studio%20lighting%20clean%20simple%20neutral%20background&width=120&height=120&seq=avatar-05&orientation=squarish',
    rating: 5,
    comment: '安全保障做得很到位，实名认证和资金托管都让我很放心。界面也很精美，每次打开都有好心情，j9是我最信任的平台。',
    date: '2026-07-15',
  },
];

export const gameCategories = [
  {
    id: 'slots',
    name: '电子游艺',
    icon: 'ri-vip-diamond-line',
    description: '数千款电子游戏，炫酷画面，高额奖金，畅享指尖狂欢',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20abstract%20digital%20entertainment%20concept%20with%20vibrant%20warm%20gradients%20and%20glowing%20particles%20on%20dark%20sophisticated%20background%20premium%20gaming%20aesthetic&width=600&height=400&seq=cat-slots&orientation=landscape',
  },
  {
    id: 'live',
    name: '真人视讯',
    icon: 'ri-live-line',
    description: '真人荷官在线发牌，高清直播流畅不卡顿，身临其境体验',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20gaming%20table%20with%20warm%20golden%20lighting%20and%20rich%20crimson%20accents%20premium%20casino%20atmosphere%20sophisticated%20dark%20background&width=600&height=400&seq=cat-live&orientation=landscape',
  },
  {
    id: 'sports',
    name: '体育竞猜',
    icon: 'ri-football-line',
    description: '全球热门赛事全覆盖，实时赔率更新，专业数据分析助您取胜',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20warm%20lighting%20and%20energy%20golden%20hour%20glow%20professional%20sporting%20event%20high%20contrast&width=600&height=400&seq=cat-sports&orientation=landscape',
  },
  {
    id: 'esports',
    name: '电竞竞技',
    icon: 'ri-computer-line',
    description: 'LOL、DOTA2、CS:GO等顶级电竞赛事竞猜，年轻玩家的首选',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20dramatic%20warm%20neon%20accents%20and%20atmospheric%20lighting%20competitive%20gaming%20stage%20dark%20sophisticated%20background&width=600&height=400&seq=cat-esports&orientation=landscape',
  },
  {
    id: 'board',
    name: '棋牌游戏',
    icon: 'ri-billiards-line',
    description: '经典棋牌游戏合集，斗地主、麻将、德州扑克应有尽有',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20card%20game%20setup%20with%20warm%20golden%20and%20deep%20red%20accents%20premium%20playing%20cards%20on%20dark%20velvet%20surface%20sophisticated%20lighting&width=600&height=400&seq=cat-board&orientation=landscape',
  },
  {
    id: 'lottery',
    name: '彩票投注',
    icon: 'ri-ticket-line',
    description: '多种官方彩票在线投注，开奖结果实时同步，大奖触手可及',
    image: 'https://readdy.ai/api/search-image?query=Golden%20lottery%20balls%20with%20warm%20sparkling%20lights%20on%20dark%20elegant%20background%20premium%20lucky%20atmosphere%20festive%20glowing%20celebration%20mood&width=600&height=400&seq=cat-lottery&orientation=landscape',
  },
];

export const promotions = [
  {
    id: 1,
    title: '新用户首充豪礼',
    description: '新用户首次充值即享100%返利，最高赠送888元，让您的游戏资金翻倍起航！',
    tag: '限时活动',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20gift%20box%20with%20golden%20ribbon%20on%20dark%20elegant%20background%20with%20warm%20sparkling%20particles%20premium%20celebration%20atmosphere%20festive%20mood&width=700&height=400&seq=promo-01&orientation=landscape',
    color: 'from-accent-600 to-accent-500',
  },
  {
    id: 2,
    title: '每日签到领金币',
    description: '每天登录签到即可领取免费金币，连续签到7天更有额外惊喜大礼包等你拿！',
    tag: '长期有效',
    image: 'https://readdy.ai/api/search-image?query=Golden%20coins%20stacked%20elegantly%20with%20warm%20glowing%20light%20on%20dark%20luxurious%20background%20wealth%20and%20prosperity%20aesthetic%20premium%20feel&width=700&height=400&seq=promo-02&orientation=landscape',
    color: 'from-primary-600 to-primary-500',
  },
  {
    id: 3,
    title: '好友邀请双赢计划',
    description: '邀请好友注册并充值，双方均可获得丰厚奖励，邀请越多奖励越多无上限！',
    tag: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=Two%20people%20celebrating%20together%20with%20warm%20golden%20confetti%20on%20dark%20elegant%20background%20friendship%20and%20success%20premium%20atmosphere%20joyful%20mood&width=700&height=400&seq=promo-03&orientation=landscape',
    color: 'from-accent-700 to-accent-500',
  },
];

export const faqs = [
  {
    question: 'j9平台如何注册账号？',
    answer: '注册j9账号非常简单快捷。点击网站右上角的"j9注册"按钮，填写手机号码或邮箱地址，设置登录密码，完成手机验证码或邮箱验证即可。整个注册流程仅需1分钟，注册成功后即可享受平台全部服务。',
  },
  {
    question: 'j9平台提款需要多长时间？',
    answer: 'j9平台采用智能审核系统，大部分提款申请可在5-10分钟内完成审核并到账。具体到账时间取决于您选择的提款方式：电子钱包通常即时到账，银行卡转账一般在30分钟内到账。我们承诺以最快的速度处理每一笔提款申请。',
  },
  {
    question: 'j9平台是否安全可靠？',
    answer: 'j9平台持有正规运营牌照，采用国际标准的SSL加密技术和多重安全防护体系，确保用户信息和资金安全。平台严格遵守相关法律法规，所有游戏均经过公平性认证，用户可以放心使用。',
  },
  {
    question: 'j9支持哪些支付方式？',
    answer: 'j9平台支持多种便捷支付方式，包括银行卡转账、微信支付、支付宝、USDT等主流支付渠道。充值实时到账，提款快速处理，全方位满足您的资金管理需求。',
  },
  {
    question: 'j9有哪些优惠活动？',
    answer: 'j9平台为新老用户准备了丰富的优惠活动，包括新用户首充100%返利、每日签到领金币、好友邀请双赢计划、节日专属福利、VIP等级特权等。活动规则透明公开，奖励即时发放，让您玩得尽兴、赚得开心。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: 'j9平台提供7×24小时全天候在线客服服务。您可以通过网站右下角的在线客服按钮、官方客服电话、或发送邮件至客服邮箱与我们取得联系。我们的专业客服团队会在第一时间为您解答疑问、处理问题。',
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年最受欢迎的综合娱乐平台推荐——j9平台深度评测',
    excerpt: '本文将全面解析j9平台的核心优势、游戏种类、安全保障及用户体验，帮助您选择最适合的娱乐平台。作为行业领先的综合娱乐平台，j9在各个方面都展现出了卓越的品质和专业的服务态度。',
    category: '平台资讯',
    date: '2026-08-05',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20gaming%20platform%20interface%20with%20warm%20golden%20accents%20on%20dark%20sophisticated%20background%20premium%20digital%20entertainment%20aesthetic%20professional%20atmosphere&width=800&height=450&seq=article-01&orientation=landscape',
    content: `在当今数字化娱乐时代，选择一个安全可靠、体验优质的综合娱乐平台至关重要。j9平台作为国内领先的综合娱乐服务平台，凭借其丰富的游戏资源、安全的支付体系以及卓越的用户体验，赢得了数百万用户的信赖与好评。

## 平台实力雄厚

j9平台拥有一支由行业资深专家组成的技术和运营团队，采用国际领先的技术架构，确保平台运行稳定流畅。平台日均活跃用户超过百万，累计注册用户突破500万，充分证明了其在行业中的领先地位和用户的广泛认可。

## 游戏种类丰富

j9平台涵盖电子游艺、真人视讯、体育竞猜、电竞竞技、棋牌游戏、彩票投注等六大品类，共计3000余款精品游戏。无论您是喜欢刺激的电子游戏、注重策略的棋牌对战，还是热爱体育赛事竞猜，都能在j9找到心仪的选择。

## 安全支付保障

平台采用银行级SSL加密技术和多重安全防护机制，所有交易均经过严格审核和实时监控。支持多种主流支付方式，充值秒到账、提款急速处理，为用户提供安全便捷的资金管理体验。

## 优惠活动给力

j9平台为新老用户准备了丰富多样的优惠活动，新用户首充100%返利、每日签到奖励、好友邀请双赢计划等福利让您的游戏体验更加超值。活动规则透明公开，奖励即时发放，真正做到让利于用户。

## 用户体验至上

从界面设计到操作流程，j9平台始终坚持用户至上的理念。简洁直观的界面布局、流畅顺滑的操作体验、7×24小时全天候客服支持，让每一位用户都能享受到极致的娱乐体验。`,
  },
  {
    id: 2,
    title: 'j9平台新用户注册指南：三步轻松开启娱乐之旅',
    excerpt: '手把手教您完成j9平台注册流程，从账号创建到安全设置，让您快速上手，安心享受平台丰富游戏和超值优惠。',
    category: '使用教程',
    date: '2026-08-03',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20registration%20screen%20on%20smartphone%20with%20warm%20golden%20highlights%20dark%20elegant%20background%20user%20friendly%20interface%20premium%20digital%20experience&width=800&height=450&seq=article-02&orientation=landscape',
    content: `欢迎来到j9平台！本文将为您详细介绍j9平台的注册流程，只需三步即可完成注册，开启精彩娱乐之旅。

## 第一步：访问官方入口

请通过j9官方平台官网入口访问，点击页面右上角的"j9注册"按钮进入注册页面。请务必认准官方网站，避免通过不明链接进入仿冒网站造成损失。

## 第二步：填写注册信息

在注册页面填写您常用的手机号码或邮箱地址，设置一个安全性较高的登录密码（建议包含字母、数字和特殊符号的组合），然后获取并填写短信验证码或邮箱验证码。

## 第三步：完成安全设置

注册成功后，建议您立即完成实名认证和绑定安全手机，这些措施将有效保障您的账户安全。完成认证后，即可开始探索j9平台丰富的游戏世界和超值优惠活动。

## 温馨提示

- 请使用真实有效的手机号码或邮箱注册，便于后续找回密码和接收重要通知
- 密码请勿与其它平台使用相同密码，建议定期更换
- 请妥善保管您的账户信息，切勿向他人透露登录密码`,
  },
  {
    id: 3,
    title: 'j9平台安全体系全解析：多重防护让您无忧娱乐',
    excerpt: '深入了解j9平台的安全保障机制，从数据加密到资金托管，从身份认证到风险监控，全方位守护您的娱乐安全。',
    category: '平台资讯',
    date: '2026-08-01',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%20with%20warm%20golden%20glowing%20protection%20symbol%20on%20dark%20sophisticated%20background%20cybersecurity%20premium%20aesthetic%20trust%20and%20safety&width=800&height=450&seq=article-03&orientation=landscape',
    content: `在网络安全日益重要的今天，j9平台始终将用户安全置于首位，建立了全方位、多层次的安全防护体系。

## 数据加密技术

j9平台采用银行级SSL/TLS加密协议，所有用户数据传输均经过高强度加密处理，确保信息在传输过程中不被窃取或篡改。平台还部署了Web应用防火墙，有效防御各类网络攻击。

## 资金安全保障

用户资金实行独立托管制度，与平台运营资金严格分离。所有资金流动均需要多重验证，并由专业风控团队7×24小时实时监控，确保每一笔交易的安全可靠。

## 身份认证体系

平台实行严格的实名认证制度，采用人脸识别、身份证验证等多重身份核验技术，杜绝虚假注册和账号盗用风险，为每位用户营造公平安全的娱乐环境。

## 游戏公平性保障

j9平台所有游戏均采用经过国际认证的随机数生成器，游戏结果完全随机、不可预测。平台定期接受第三方权威机构审计，确保游戏的公平性和透明度。
`,
  },
  {
    id: 4,
    title: 'j9平台优惠活动大盘点：2026年最值得参与的福利',
    excerpt: '整理j9平台当前所有热门优惠活动，包括新用户福利、每日签到、充值返利、节日特惠等，让您不错过任何一个赚钱机会。',
    category: '优惠活动',
    date: '2026-07-30',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20golden%20gift%20packages%20with%20sparkling%20particles%20on%20dark%20elegant%20background%20premium%20promotion%20celebration%20atmosphere%20festive%20and%20warm%20mood&width=800&height=450&seq=article-04&orientation=landscape',
    content: `j9平台一直以丰厚的优惠活动回馈用户，2026年更是推出了多项超值福利。本文为您全面盘点了当前最值得参与的热门活动。

## 新用户专属福利

首次注册并充值的用户可享受100%充值返利，最高赠送888元。这是新用户体验平台的最佳时机，用翻倍的资金畅玩各类游戏。

## 每日签到奖励

坚持每日登录签到即可领取免费金币，连续签到第3天、第7天还可获得额外惊喜奖励。养成签到好习惯，积少成多收获满满。

## 好友邀请计划

邀请好友通过您的专属链接注册j9平台，双方均可获得丰厚现金奖励。邀请越多，奖励越多，上不封顶！

## VIP会员专享

成为j9平台VIP会员即可享受更高返利比例、专属客服通道、生日礼包、优先提款等多项特权服务。等级越高，福利越丰厚。

## 节日主题活动

每逢重要节日，j9平台都会推出限时主题活动，包括抽奖、竞赛、限时加倍返利等，奖品丰富、惊喜不断。`,
  },
  {
    id: 5,
    title: 'j9平台移动端体验：随时随地畅享娱乐',
    excerpt: 'j9平台全面适配移动端，无论是手机浏览器还是APP，都能为您提供流畅便捷的游戏体验。本文带您了解j9移动端的各项优势。',
    category: '使用教程',
    date: '2026-07-28',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20premium%20gaming%20app%20interface%20with%20warm%20golden%20and%20dark%20elegant%20design%20on%20luxurious%20desk%20setting%20modern%20lifestyle%20aesthetic&width=800&height=450&seq=article-05&orientation=landscape',
    content: `随着移动互联网的普及，越来越多的用户选择在手机上享受娱乐体验。j9平台针对移动端进行了全面优化，让您随时随地都能畅享精彩。

## 无需下载，即开即玩

j9平台采用H5技术，无需下载安装任何APP，通过手机浏览器即可直接访问平台全部功能。界面自适应适配各种屏幕尺寸，操作流畅、画质清晰。

## 专属APP体验更佳

对于追求更佳体验的用户，j9也提供了官方APP下载。APP版本针对移动端进行了深度优化，加载更快、推送及时、功能更全，推荐深度用户使用。

## 功能全面不缩水

移动端版本与PC端功能完全同步，包括游戏大厅、充值提款、优惠活动、客服咨询等所有功能一应俱全，不会因为使用手机而错过任何福利。

## 流量优化省流量

j9平台针对移动网络进行了流量优化，在保证画质的前提下尽可能降低流量消耗，让您无需担心流量问题，放心畅玩。`,
  },
  {
    id: 6,
    title: 'j9平台客服体系介绍：您的专属服务管家',
    excerpt: 'j9平台建立了完善的客户服务体系，7×24小时全天候在线，多渠道快速响应，致力于为每一位用户提供专业、贴心的服务体验。',
    category: '平台资讯',
    date: '2026-07-25',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Professional%20customer%20service%20team%20working%20in%20modern%20office%20with%20warm%20lighting%20and%20golden%20accents%20dark%20elegant%20interior%20premium%20corporate%20atmosphere&width=800&height=450&seq=article-06&orientation=landscape',
    content: `优质的服务是j9平台赢得用户信赖的重要基石。我们建立了全方位、多层次的客户服务体系，确保每位用户都能获得及时、专业的帮助。

## 多渠道服务覆盖

用户可通过在线客服（网站右下角悬浮按钮）、官方客服电话、电子邮件、微信公众号等多种渠道联系j9客服团队。无论您偏好哪种沟通方式，我们都能满足您的需求。

## 7×24小时全天候响应

j9客服团队实行三班倒工作制，确保全天候均有专业客服在线值守。无论您在凌晨还是节假日遇到问题，都能获得及时的响应和帮助。

## 专业培训体系

所有客服人员均经过严格的岗前培训和定期考核，具备专业的产品知识和出色的沟通能力，能够快速准确地理解和解决用户的问题。

## 问题处理时效

一般咨询类问题5分钟内响应，账户相关问题30分钟内处理完成，提款相关问题优先处理。我们承诺以最快的速度响应每一位用户的需求。`,
  },
];

export const categories = [
  {
    id: 'all',
    name: '全部',
    icon: 'ri-apps-line',
  },
  {
    id: 'platform',
    name: '平台资讯',
    icon: 'ri-building-line',
  },
  {
    id: 'tutorial',
    name: '使用教程',
    icon: 'ri-book-open-line',
  },
  {
    id: 'promotion',
    name: '优惠活动',
    icon: 'ri-gift-line',
  },
];